import { FC, ReactNode } from 'react'
import { EmployeeAvatar, EmployeeAvatarType } from './Avatar'
import { Form, FormType } from './form/Form'
import { EmployeeOption, EmployeeOptionType } from './Option'

export const Employee: FC &
  EmployeeAvatarType &
  FormType &
  EmployeeOptionType = (): ReactNode => <></>

Employee.Avatar = EmployeeAvatar
Employee.Form = Form
Employee.Option = EmployeeOption
